import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/app/app/layouts/partnersSeo/default.vue").then(m => m.default || m)),
  "empty-p": defineAsyncComponent(() => import("/app/app/layouts/partnersSeo/emptyP.vue").then(m => m.default || m))
}